import React, {useEffect} from "react";
import PropTypes from "prop-types";
import {useSelector, useDispatch} from "react-redux";
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import CardHeader from "@mui/material/CardHeader";
import CardActions from "@mui/material/CardActions";
import Typography from "@mui/material/Typography";
import Divider from "@mui/material/Divider";
import {initializeAuthorization, setToken, rejectLogin} from "../../actions/loginActions";
import ArgoAppBarHook from "../common/ArgoAppBarHook";
import ssoButton from "./SSOButton"
import {debugLog} from "../../utilities/debugLogger";

const LoginPage = (props) => {
    const dispatch = useDispatch();
    const loggedIn = useSelector(state => state.login.loggedIn);
    const message = useSelector(state => state.login.message);

    const {children} = props;

    useEffect(() => {
        dispatch(initializeAuthorization());
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const handleSetToken = (token) => {
        dispatch(setToken(token));
    };

    const handleRejectLogin = (error) => {
        dispatch(rejectLogin(error));
    };

    if (loggedIn) {
        return children;
    }

    let prev = localStorage.getItem("hasSeenWelcomeMessage");
    if (prev === null) {
        localStorage.setItem("hasSeenWelcomeMessage", "false");
        debugLog('WELCOME','Initialized hasSeenWelcomeMessage -> false');
    }

    return (
        <div style={{height: "100%", minHeight: "100vh", width: "100%", overflow: "hidden", background: "#ffffff", display:'flex', flexDirection:'column'}}>
            <ArgoAppBarHook showMenuIconButton={false}/>
            <Grid container alignItems="center" justifyContent="center" sx={{flex:1, py:6}}>
                <Grid item>
                    <Card elevation={6} sx={{
                        width: 420,
                        borderRadius: 4,
                        background: '#ffffff',
                        border: '1px solid #e0e0e0'
                    }}>
                        <CardHeader
                            title={<Typography variant="h6" sx={{fontWeight:'600', letterSpacing:.5}}>Please sign in to continue</Typography>}
                            sx={{pb:0, textAlign:'center'}}
                        />
                        <CardContent sx={{pt:2}}>
                            <div style={{display:'flex', justifyContent:'center', marginBottom:16, marginTop:8}}>
                                <img src={process.env.PUBLIC_URL + '/argoRed.ico'} alt="Argo" style={{height:56, width:56}}/>
                            </div>
                            <Divider sx={{mb:3}}/>
                            <Typography variant="body2" color="text.secondary" align="center" sx={{mb:2}}>
                                Sign in with your corporate Azure account
                            </Typography>
                            {message ?
                                <div style={{backgroundColor: "#ffebee", border:'1px solid #ffcdd2', color: "#b71c1c", whiteSpace: "pre-line", padding:"8px 12px", borderRadius:4, fontSize:'0.8rem', marginTop:'4px'}}>
                                    {message}
                                </div> : null}
                        </CardContent>
                        <CardActions sx={{px:3, pb:3, pt:1, justifyContent:'center'}}>
                            {ssoButton(handleSetToken, handleRejectLogin)}
                        </CardActions>
                    </Card>
                </Grid>
            </Grid>
            <Typography variant="caption" color="text.secondary" align="center" sx={{pb:2}}>
                © {new Date().getFullYear()} Argo Data – All rights reserved
            </Typography>
        </div>
    );
};

LoginPage.propTypes = {
    children: PropTypes.node.isRequired
};

export default LoginPage;
